import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { NamirasoftERPMetaDatabase, TagGroupRow, TagInputRow, TagRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class TagEditPage extends Component<Props>
{
    TagGroup = createRef<NSBoxEntity<TagGroupRow>>();
    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();
    Enabled = createRef<NSBoxBoolean>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<TagRow, TagInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.tag(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): TagInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        tag_group_id: this.TagGroup.current?.getValueOne() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        tag_category: [],
                                        tag_tag: [],
                                        tag_field: [],
                                    }),
                                    setRow: (row: TagRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.TagGroup.current?.setValueOne(row.tag_group_id);
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                        this.Enabled.current?.setValueBool(row.enabled);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<TagGroupRow>
                        ref={this.TagGroup} title="Tag Group" info={{ link: "https://namirasoft.com/erp/console-guide/tag/#field-tag-group-id" }} required multiple={false}
                        table_name="tag_group" table={db.tables.tag_group}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.tag_group, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.tag_group, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.tag_group.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/tag/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/tag/#field-description" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/tag/#field-enabled" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}